import '../faust.config';
import React from 'react';
import Head from 'next/head';
import { FaustProvider } from '@faustwp/core';
import '@faustwp/core/dist/css/toolbar.css';
import '../styles/global.scss';
import { LanguageProvider } from '../contexts/LanguageContext';
import { SyncLanguageFromPath } from '../contexts/SyncLanguageFromPath';
import { LanguageSwitcherProvider } from '../contexts/LanguageSwitcherContext';
import { ConsentProvider } from '../contexts/ConsentContext';
import { CookieBanner } from '../components/CookieBanner';
import { GoogleAnalytics } from '../components/GoogleAnalytics';
import { HubSpotScript } from '../components/HubSpotScript';

export default function MyApp({ Component, pageProps }) {
  return (
    <>
      <Head>
        <link rel="icon" type="image/png" href="/favicon.png" />
        <link rel="apple-touch-icon" href="/favicon.png" />
        <meta name="google-site-verification" content="sJ-E5lhK66hGEYEuTw6Ie0q02Y565GgfnJckp8mZ6Hc" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400&display=swap"
          rel="stylesheet"
        />
      </Head>
      <FaustProvider pageProps={pageProps}>
        <LanguageProvider>
          <SyncLanguageFromPath>
            <LanguageSwitcherProvider>
              <ConsentProvider>
                <Component {...pageProps} />
                <CookieBanner />
                <GoogleAnalytics />
                <HubSpotScript />
              </ConsentProvider>
            </LanguageSwitcherProvider>
          </SyncLanguageFromPath>
        </LanguageProvider>
      </FaustProvider>
    </>
  );
}
